import { render, staticRenderFns } from "./InstallersProfile.vue?vue&type=template&id=15afd0b4&scoped=true"
import script from "./InstallersProfile.vue?vue&type=script&lang=js"
export * from "./InstallersProfile.vue?vue&type=script&lang=js"
import style0 from "./InstallersProfile.vue?vue&type=style&index=0&id=15afd0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15afd0b4",
  null
  
)

export default component.exports